module.exports = __webpack_public_path__ + "static/media/telr.492bb0cc.jpg";